import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import LoginPage from '../routes/LoginPage';
import HomePage from '../routes/HomePage';
import TrafficPage from '../routes/TrafficPage';
import SubscriptionPage from '../routes/SubscriptionPage';

const Routing = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <LoginPage />
        },
        {
            path:"/home",
            element:<HomePage />
        },
        {
            path:"/publisher-traffic",
            element:<TrafficPage />
        },
        {
            path:"/publisher-subscription",
            element:<SubscriptionPage />
        },
        {
            path:"*",
            element:<Navigate to="/" />
        }
    ])
    return (
        <RouterProvider router={router} />
    )
}

export default Routing